import { CRM_PREFIX, defaultRequest } from '@/config/api'
import axios from 'axios'

const axiosCrmInstance = axios.create({
    baseURL: CRM_PREFIX || window.location.origin,
    ...defaultRequest
})

export default axiosCrmInstance
